import React, { useEffect, useRef, useState } from "react";
import "./feedback-strip.css";

export default function FeedbackStrip({
  items = [],
  visible = 2,        // số card nhìn thấy
  gap = 12,           // px
  autoSpeed = 0.6,    // px/frame (≈60fps) – nhỏ hơn = chậm hơn
  resumeDelay = 1200  // ms: thả chuột bao lâu thì chạy lại
}) {
  const loop = [...items, ...items];              // nhân đôi để chạy vô hạn
  const stripRef = useRef(null);
  const [isDown, setIsDown] = useState(false);
  const startX = useRef(0);
  const startLeft = useRef(0);
  const rafId = useRef(null);
  const hoverRef = useRef(false);
  const resumeTimer = useRef(null);

  // Native auto-scroll bằng scrollLeft (dễ kết hợp kéo chuột)
  useEffect(() => {
    const el = stripRef.current;
    if (!el) return;

    const tick = () => {
      // nếu đang hover hoặc kéo thì tạm dừng
      if (!isDown && !hoverRef.current) {
        el.scrollLeft += autoSpeed;
      }
      // reset để cuộn vô hạn (vì đã nhân đôi nội dung)
      const half = el.scrollWidth / 2;
      if (el.scrollLeft >= half) el.scrollLeft -= half;
      if (el.scrollLeft < 0) el.scrollLeft += half;

      rafId.current = requestAnimationFrame(tick);
    };
    rafId.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId.current);
  }, []);

  // Handlers kéo chuột
  const onPointerDown = (e) => {
    const el = stripRef.current;
    if (!el) return;
    el.setPointerCapture?.(e.pointerId);
    setIsDown(true);
    // dừng auto cho “mượt”
    hoverRef.current = true;
    clearTimeout(resumeTimer.current);

    startX.current = e.clientX;
    startLeft.current = el.scrollLeft;
  };

  const onPointerMove = (e) => {
    if (!isDown) return;
    const el = stripRef.current;
    const dx = e.clientX - startX.current;
    el.scrollLeft = startLeft.current - dx;

    // giữ vô hạn khi kéo
    const half = el.scrollWidth / 2;
    if (el.scrollLeft >= half) el.scrollLeft -= half;
    if (el.scrollLeft < 0) el.scrollLeft += half;
  };

  const endDrag = (e) => {
    if (!isDown) return;
    setIsDown(false);
    // resume auto sau một lúc
    resumeTimer.current = setTimeout(() => {
      hoverRef.current = false;
    }, resumeDelay);
  };

  // Hover để dừng (desktop)
  const onMouseEnter = () => (hoverRef.current = true);
  const onMouseLeave = () => {
    if (!isDown) hoverRef.current = false;
  };

  return (
    <div
      className="fb-strip is-scroll"
      style={{ ["--visible"]: visible, ["--gap"]: `${gap}px` }}
      ref={stripRef}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={endDrag}
      onPointerCancel={endDrag}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="fb-track">
        {loop.map((it, idx) => (
          <article className="fb-card mb-3" key={idx}>
            <div  className="fb-img" style={{ backgroundImage: `url(${it.src})` }}></div>
            <div className="fb-body">
              <div className="fb-school">{it.school_name}</div>
              <div className="fb-name">{it.represent}</div>
              {it.cmt && <div className="fb-text">{it.cmt}</div>}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
